import styled from 'styled-components';

import { Box, Divider, Typography } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: ${wellzTheme.spacing(57)};
  padding: ${wellzTheme.spacing(2)} ${wellzTheme.spacing(4)};
  background-color: ${wellzTheme.palette.background.paper};
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${wellzTheme.spacing(1)};
  justify-content: center;
  margin-bottom: ${wellzTheme.spacing(1)};
`;

export const CompanyWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: fit-content;
`;

export const Company = styled(Typography).attrs({ variant: 'body2' })`
  color: ${wellzTheme.palette.text.secondary};

  span {
    color: ${wellzTheme.palette.text.secondary};
    margin-right: ${wellzTheme.spacing(1)};
    font-weight: ${wellzTheme.typography.fontWeightBold};
  }
`;

export const Body = styled.div`
  width: 100%;
  height: ${wellzTheme.spacing(8)};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BigNumbers = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const BigNumbersLabel = styled(Typography).attrs({ variant: 'body2' })`
  color: ${wellzTheme.palette.text.secondary};
  display: flex;
  align-items: center;

  > svg {
    fill: ${wellzTheme.palette.action.active};
    margin-left: ${wellzTheme.spacing(0.5)};
    height: 20px;
    width: 20px;
  }
`;

export const StyledDivider = styled(Divider)`
  margin: ${wellzTheme.spacing(0.5)} 0;
`;

export const SubscriptionStatusColor = styled.span<{ color?: string }>`
  color: ${({ color }) => color || 'inherit'};
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const StatusContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const StatusText = styled(Typography).attrs({ variant: 'body2' })<{
  isMultiline: boolean;
}>`
  color: ${wellzTheme.palette.text.secondary};
  display: flex;
  flex-direction: ${({ isMultiline }) => (isMultiline ? 'column' : 'row')};
  align-items: ${({ isMultiline }) => (isMultiline ? 'flex-start' : 'center')};
  text-align: left;
`;

export const TooltipText = styled(Typography).attrs({ variant: 'body2' })`
  color: ${wellzTheme.palette.text.secondary};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${wellzTheme.palette.action.active};
    margin-left: ${wellzTheme.spacing(0.5)};
    height: 20px;
    width: 20px;
  }
`;
